var map = {
	"./C215016359/fileset/dimming.txt": 9177,
	"./C215016359/fileset/edid-dp1.txt": 870,
	"./C215016359/fileset/edid-dp2.txt": 8417,
	"./C215016359/fileset/edid-dvi-d1.txt": 4580,
	"./C215016359/fileset/edid-dvi-d2.txt": 5763,
	"./C215016359/fileset/monitorinfo.txt": 4210,
	"./C215016359/fileset/paneltimings.txt": 815,
	"./C215016359/fileset/wave_cfg.txt": 2108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7372;